module.exports = __webpack_public_path__ + "static/media/mazaZolePlayed_100000_250000.073b2a9a.png";